export enum ReviewType {
  None = '',
  Alert = 'Alert',
  NeedsReview = 'Needs Review'
}
